import i18n from '@/i18n';

export default [
  {
    path: '/invoices',
    name: 'invoices',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'invoice',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('invoices')
    },
    // route level code-splitting
    component: () =>
      import('../../views/invoices/Index'),
    children: [
      {
        path: ':id(\\d+)',
        name: 'invoices-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'invoice',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('invoices'),
        },
        component: () => import('../../views/invoices/Edit.vue'),
      },
    ],
  },
  {
    path: '/invoice/download/:token/:source/:emailId?',
    name: 'invoice-download',
    meta: {
      loadState: true,
      auth: false,
      isAuthPage: false,
      permissions: [],
      title: i18n.global.t('download_invoice')
    },
    // route level code-splitting
    component: () =>
      import('../../views/invoices/Download'),
  },
];
